module.exports = __webpack_public_path__ + "img/dsci0151.8b3e4bb0.jpg";